const saveChangesTemplate = `
<div class="modal-header auto-increase">
    <div class="modal-title" id="modal-title">
        {{ enrollCtrl.getTitle() }}
    </div>
    <hr class="hr-auto-increase" />
</div>
<div class="modal-body auto-increase">
    <div class="row">
        <div class="col-sm-12">
            <p>{{ enrollCtrl.getMessage() }}</p>
        </div>
    </div>
    <div class="row"></div>
    <div class="modal-footer auto-increase">
        <button
            type="button"
            class="btn btn-default pull-left"
            ng-click="enrollCtrl.onCancelClick()"
            ng-if="enrollCtrl.isEnroll"
        >
            {{'header.saveChanges.cancel' | translate }}
        </button>
        <button ng-if="!enrollCtrl.isEnroll"
            class="cancel-link btn-link"
            ng-click="enrollCtrl.onCancelClick()"
        >
            {{'header.saveChanges.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" ng-click="enrollCtrl.onContinueClick($event)">
            {{'header.saveChanges.continue' | translate }}
        </button>
    </div>
</div>
`;
export default saveChangesTemplate;
